/* ============================================================================
   Tamanho de pagina do sistema, em UM lugar.

   Antes cada tela declarava o seu (`const PADRAO_LINHAS = 25` repetido em 8
   arquivos, mais 4 com `LINHAS_POR_PAGINA` fixo). Mudar "o padrao de todas as
   listas" era achar doze lugares e nao esquecer nenhum - e o que se esquece fica
   divergente sem ninguem notar, porque cada tela parece certa isolada.
   ============================================================================ */

/**
 * "Ver todos" - o maior `rows` que os endpoints aceitam.
 *
 * 1000 nao e numero escolhido por gosto: e o TETO do backend. A consulta de
 * dispositivos limita `rows` a 1000 (dispositivos.service.ts) e pedir mais devolve
 * 1000 em silencio. Chamar isso de "todos" e uma simplificacao consciente - com
 * 31 mil dispositivos, "todos" de verdade nao existe nesta rota -, e por isso o
 * rodape das listas continua dizendo quantos registros existem no total.
 */
export const TODAS_AS_LINHAS = 1000;

/**
 * Linhas por pagina conforme a ALTURA da janela: 5 em tela HD, 11 em Full HD.
 *
 * O numero do Full HD foi ajustado OLHANDO A TELA, varias vezes: 15 apertava, 10
 * sobrava espaco, 12 quase, 11 fechou. Nao ha conta por tras - e por isso que ele
 * vive num lugar so: cada mudanca dessas seria uma cacada de doze arquivos se o
 * valor estivesse espalhado, e o proximo ajuste e uma linha.
 *
 * MEDE ALTURA, e nao largura, porque a pergunta real e "quantas linhas cabem sem
 * rolar" - e isso depende da altura. Largura nao diz nada sobre isso: uma janela
 * 1920x600 e larga e baixa.
 *
 * O CORTE EM 800px: em HD (1366x768) sobram ~700px de viewport, e no Windows com
 * escala de 125% - o caso da maquina onde isso apareceu - viram ~560px CSS.
 * Descontando faixa superior, abas, cabecalho, cartoes e filtros, a lista fica com
 * pouco mais de 200px.
 *
 * NAO REAGE A REDIMENSIONAMENTO de proposito: o tamanho da pagina vai na CONSULTA
 * ao servidor, entao mudar com o arrastar da janela dispararia uma busca por
 * quadro, e a lista pularia embaixo da mao de quem esta lendo. Vale o tamanho de
 * quando a tela abriu; quem quiser outro usa o seletor de linhas.
 *
 * `typeof window` protegido: este modulo tambem e importado em escopo de modulo
 * (constante de tela), e um dia isso pode ser avaliado fora do navegador.
 */
export function linhasIniciais(): number {
  if (typeof window === 'undefined') return 11;
  return window.innerHeight < 800 ? 5 : 11;
}

/**
 * Fallback para quem precisa de um numero constante (nao reativo).
 * Preferir `linhasIniciais()`.
 */
export const PADRAO_LINHAS = 11;

/**
 * Opcoes do seletor de linhas.
 *
 * O 5 e o 11 estao aqui porque sao os valores que `linhasIniciais` devolve, e um
 * seletor cujo valor atual nao esta entre as opcoes aparece EM BRANCO - aconteceu
 * quando o padrao virou 10 e tres telas ofereciam apenas 25/50/100. Os pedidos
 * eram 5, 15, 20 e "ver todos"; o 11 entra por necessidade tecnica, nao por gosto.
 */
/* O 8 entrou em 10/09/2026, a pedido. Ele preenche o vao entre 5 (tela de
   1366x768, onde 11 nao cabe) e 11 (Full HD): em notebook de 1440x900 cabem
   oito linhas com o rodape visivel, e sem essa opcao a escolha era rolar ou
   perder tres linhas de tela. */
export const OPCOES_LINHAS = [5, 8, 11, 15, 20, TODAS_AS_LINHAS];

/** Rotulo da opcao no seletor. `TODAS_AS_LINHAS` aparece como "Todos". */
export function rotuloLinhas(n: number): string {
  return n === TODAS_AS_LINHAS ? 'Todos' : String(n);
}
